import 'swiper/css';

import { theme, useMediaQuery, Flex } from '@everlywell/ui-kit';
import CardBuilder from 'components/CardBuilder';
import CardsAccordion, { CardsAccordionProps } from 'components/CardsAccordion';
import MultipleCardsSwiper, {
  MultipleCardsSwiperProps,
} from 'components/MultipleCardsSwiper';
import React from 'react';

export type CardsCarouselAccordionProps = {
  carouselCards: MultipleCardsSwiperProps['cards'];
  accordionCards: CardsAccordionProps['items'];
  carouselFadeBgColor?: string;
  carouselStyles?: MultipleCardsSwiperProps['style'];
  disableAccordion?: boolean;
};

const CardsCarouselAccordion = ({
  carouselCards,
  accordionCards,
  carouselFadeBgColor,
  carouselStyles,
  disableAccordion = false,
}: CardsCarouselAccordionProps) => {
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.tablet})`);

  if (isMobile && disableAccordion) {
    return (
      <Flex display="flex" flexDirection="column" marginTop={4} gap={4}>
        {accordionCards.map(({ button, content }) =>
          [button, ...content].map(({ componentName, ...cardProps }, index) => (
            <CardBuilder
              key={`${componentName}-${index}`}
              componentName={componentName}
              {...cardProps}
            />
          )),
        )}
      </Flex>
    );
  }

  if (isMobile && !disableAccordion)
    return <CardsAccordion items={accordionCards} />;

  return (
    <MultipleCardsSwiper
      cards={carouselCards}
      slideStyles={{
        flexShrink: 'unset',
        maxWidth: 'fit-content',
      }}
      showPagination={false}
      breakpointConfig={{
        0: {
          slidesPerView: 'auto',
        },
        900: {
          slidesPerView: 'auto',
        },
        1200: {
          slidesPerView: 'auto',
        },
      }}
      fadeBgColor={carouselFadeBgColor}
      mousewheel={{
        enabled: true,
        forceToAxis: true,
      }}
      carouselStyles={carouselStyles}
      freeMode
    />
  );
};

export default CardsCarouselAccordion;
